import { render, staticRenderFns } from "./LegalDocumentContent_PWffHQ.vue?vue&type=template&id=716b9237&scoped=true&"
var script = {}
import style0 from "./LegalDocumentContent_PWffHQ.vue?vue&type=style&index=0&id=716b9237&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716b9237",
  null
  
)

export default component.exports